import { defineMessages } from 'react-intl';

export default defineMessages({
  helpNotImplemented: {
    id: 'help.notImplemented',
    defaultMessage: 'Help Not Implemented Yet'
  },
});